var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.isOptOut)?_c('v-btn',{attrs:{"disabled":_vm.isOptOut,"small":"","depressed":"","color":"error"},on:{"click":_vm.askFor}},[_vm._v(" E-Mail Opt-Out ")]):_c('v-alert',{attrs:{"border":"left","color":"primary","dark":""}},[_vm._v(" "+_vm._s(_vm.$t("leadIsOptOutMessage"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }